// extracted by mini-css-extract-plugin
export default {"room-full":"RoomFull_room-full__CN-sm","message":"RoomFull_message__zaPlQ"};